export const HANDOFF_BEAT_IDS = {
  parkedGoal: "parked_goal",
  territory: "territory",
  firstBrief: "first_brief",
} as const;

export type HandoffBeatId =
  (typeof HANDOFF_BEAT_IDS)[keyof typeof HANDOFF_BEAT_IDS];

export const HANDOFF_ANCHOR_ATTR = "data-handoff-anchor";

export const HANDOFF_READY_TIMEOUT_MS = 1500;

/** Tour 变体：已激活(贺词) / 未激活(安抚) */
export type HandoffVariant = "activated" | "unactivated";

/** Paywall 结果分支：A1 付费+完成设goal / A2 付费+中途退出 / B 未付费 */
export type HandoffBranch = "A1" | "A2" | "B";

export type HandoffSessionState = {
  active: boolean;
  beats: HandoffBeatId[];
  beatIndex: number;
  hasGoal: boolean;
  reducedMotion: boolean;
  /** Beats list resolved after probing Plan DOM */
  beatsResolved: boolean;
  variant: HandoffVariant;
  branch: HandoffBranch;
};

export type AnchorRect = {
  top: number;
  left: number;
  width: number;
  height: number;
  ready: boolean;
};
